import * as React from 'react'
import { isAdmin, isBrand, getCurrentUser, logout } from 'web-fns/dist/auth'
import { Route } from 'react-router-dom'
import { uniqBy } from 'lodash'
import Tippy from '@tippy.js/react'
import notification from 'web-makeup/dist/Notification'

import { Brand as BrandType, TypesenseDocument, BrandRelationship } from '../../../../typings/types'
import { domainHelper } from '../../../../helpers/domainHelper'

import { getDashboardId } from '../../../../helpers/getDashboardId'
import { SearchParameters, typesenseQuery, config as typesenseConfig } from '../../../../typeSense'
import { ArrowIcon, ArrowIconWhite, BulletIcon } from '../../../../assets/svgs'

import { ConciergeReports } from './ConciergeReports'
import {
  Container,
  Section,
  SectionHeader,
  SectionTitle,
  ItemList,
  Item,
  MenuItem,
  Arrow,
  SearchIcon,
  LogoWrap,
  UserAvatarWrap,
  AvatarMissing,
  AvatarStyled,
  Logo,
  Icon,
  Label,
  ChatAndActivityMenuItem,
  MenuContainer,
  SubItem,
  Wrap,
  DropdownSectionTitle,
  BrandLink,
  BrandAvatar,
  BrandItem,
  BrandName,
  ModalSeparator,
  BrandList,
  LogoutButton,
  AddSubBrand,
  ScrollableSection,
  ModalContent,
  BrandNameWrapper,
  TopWrapp,
  Account,
  SearchInput,
  SearchWrapper,
  ResultLink,
  ResultName,
  SearchSeparator,
  ResultsWrapper,
  TooltipWrapper,
  TooltipContent,
  NavTrigger,
  Hr,
} from './Navigation.style'
import Avatar, { getTwoLetter } from './Avatar'

export interface IVaasJWTUser {
  aud: string
  auth: number
  email: string
  exp: number
  family_name?: string
  given_name?: string
  iat: number
  iss: string
  locale: string
  name: string
  nickName?: string
  nonce: string
  picture: string
  sendbird_hash: string
  sid: string
  sub: string
  user: {
    avatar: string
    confirmed: boolean
    email: string
    id: number
    locale: string
    name: string
    timezone: string
    user_roles: string[]
    uuid: string
  }
}

export const IconMap = ({ id, isSelected }: { id: string; isSelected: 'default' | 'active' }) => {
  // Preload Images
  React.useEffect(() => {
    const icons = [
      'dashboard',
      'team',
      'our-brand',
      'creators',
      'billing',
      'integrations',
      'support',
      'delivery',
      'new-order',
      'matching',
      'wallets',
      'settings',
      'our-enterprise',
      'our-brand-default',
      'creators-default',
      'delivery-default',
    ]

    icons.forEach(icon => {
      const imgDefault = new Image()
      imgDefault.src = `https://res.cloudinary.com/ninety-seconds/image/upload/-design-system/icon-${icon}-default.svg`
      const imgActive = new Image()
      imgActive.src = `https://res.cloudinary.com/ninety-seconds/image/upload/-design-system/icon-${icon}-active.svg`
    })
  }, [])

  const iconStyle = { filter: 'invert(100%)' }

  switch (id) {
    case 'dashboard':
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/v1688987759/-design-system/icon-dashboard-${isSelected}.svg`}
        />
      )
    case 'productize': {
      if (isSelected === 'active') {
        return (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: '1.25rem', height: '1.25rem' }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.25577 5.73903C6.3922 2.68452 8.91177 0.25 11.9999 0.25C15.0881 0.25 17.6077 2.68452 17.7441 5.73903C17.7696 5.75012 17.795 5.76146 17.8203 5.77306C18.7052 6.17871 19.4706 6.80141 20.047 7.58057L19.2831 8.34266L18.4193 9.20647C16.7376 10.8881 15.5286 12.0949 14.4858 12.8905C13.4603 13.673 12.6842 13.9868 11.8786 13.9868C11.0729 13.9868 10.2968 13.673 9.27131 12.8905C8.2285 12.0949 7.01948 10.8881 5.33782 9.20647L3.85232 7.72097C4.43883 6.8761 5.24215 6.20279 6.17956 5.77306C6.20487 5.76146 6.23027 5.75012 6.25577 5.73903ZM7.79918 5.35109C8.65217 5.24978 9.69288 5.24987 11.0462 5.24999H12.9537C14.307 5.24987 15.3477 5.24978 16.2007 5.35109C15.8883 3.31188 14.1265 1.75 11.9999 1.75C9.87337 1.75 8.11159 3.31188 7.79918 5.35109Z"
              fill="#FFFFFF"
            />
            <path
              d="M20.7715 8.97674L20.3353 9.41183L19.4394 10.3077C17.8072 11.9399 16.5279 13.2192 15.3957 14.0831C14.2367 14.9673 13.144 15.4868 11.8786 15.4868C10.6131 15.4868 9.52037 14.9673 8.36144 14.0831C7.22918 13.2192 5.95 11.94 4.31774 10.3077L3.16985 9.15982C2.90399 10.0379 2.7484 11.1586 2.53734 12.6789L2.5161 12.8319C2.30219 14.372 2.13498 15.5759 2.08419 16.5457C2.03262 17.5303 2.095 18.3508 2.3912 19.1041C2.87532 20.3353 3.76921 21.362 4.92213 22.0109C5.62751 22.4079 6.43165 22.5825 7.41401 22.6669C8.38153 22.75 9.59703 22.75 11.1519 22.75H12.848C14.4029 22.75 15.6184 22.75 16.5859 22.6669C17.5683 22.5825 18.3724 22.4079 19.0778 22.0109C20.2307 21.362 21.1246 20.3353 21.6087 19.1041C21.9049 18.3508 21.9673 17.5303 21.9157 16.5457C21.8649 15.5759 21.6977 14.3719 21.4838 12.8318L21.4594 12.6563C21.236 11.0466 21.0745 9.88337 20.7715 8.97674Z"
              fill="#FFFFFF"
            />
          </svg>
        )
      }
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: '1.25rem', height: '1.25rem' }}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.0004 0.25C8.91226 0.25 6.39269 2.68452 6.25625 5.73903C6.23075 5.75012 6.20536 5.76146 6.18005 5.77306C5.17462 6.23397 4.32345 6.97509 3.7286 7.90756C3.5733 8.15101 3.44467 8.40771 3.33493 8.68458C2.96159 9.62653 2.78899 10.8698 2.53783 12.6789L2.51659 12.8319C2.30268 14.372 2.13546 15.5759 2.08467 16.5457C2.03311 17.5303 2.09549 18.3508 2.39169 19.1041C2.87581 20.3353 3.7697 21.362 4.92261 22.0109C5.628 22.4079 6.43214 22.5825 7.41449 22.6669C8.38202 22.75 9.59752 22.75 11.1524 22.75H12.8485C14.4034 22.75 15.6189 22.75 16.5864 22.6669C17.5687 22.5825 18.3729 22.4079 19.0783 22.0109C20.2312 21.362 21.1251 20.3353 21.6092 19.1041C21.9054 18.3508 21.9678 17.5303 21.9162 16.5457C21.8654 15.5759 21.6982 14.3719 21.4843 12.8318L21.4599 12.6563C21.194 10.7402 21.0158 9.4568 20.5823 8.48569C20.4918 8.28298 20.3895 8.09131 20.2723 7.90756C19.6774 6.97509 18.8263 6.23397 17.8208 5.77306C17.7955 5.76146 17.7701 5.75012 17.7446 5.73903C17.6082 2.68452 15.0886 0.25 12.0004 0.25ZM11.0466 5.24999C9.69337 5.24987 8.65265 5.24978 7.79966 5.35109C8.11208 3.31188 9.87386 1.75 12.0004 1.75C14.127 1.75 15.8888 3.31188 16.2012 5.35109C15.3482 5.24978 14.3075 5.24987 12.9542 5.24999H11.0466ZM7.20972 6.98719C8.00021 6.75748 9.06921 6.75 11.1883 6.75H12.8125C14.9317 6.75 16.0007 6.75748 16.7912 6.98719C16.9365 7.02942 17.0697 7.07882 17.1957 7.13661C17.9179 7.46767 18.5324 7.99432 18.97 8.65629L18.4198 9.20647C16.7382 10.8881 15.5292 12.0949 14.4863 12.8905C13.4608 13.673 12.6847 13.9868 11.8791 13.9868C11.0735 13.9868 10.2974 13.673 9.27185 12.8905C8.22904 12.0949 7.02002 10.8881 5.33836 9.20647L4.93745 8.80556C4.95559 8.77452 4.97416 8.74412 4.99319 8.71428C5.43287 8.02507 6.06199 7.47728 6.80514 7.13661C6.93119 7.07882 7.06436 7.02943 7.20972 6.98719ZM19.5497 10.1979C19.6941 10.8655 19.8194 11.7481 19.9936 13.0026C20.2135 14.5859 20.3712 15.7262 20.4183 16.6241C20.4649 17.5146 20.3966 18.089 20.2132 18.5552C19.8554 19.4653 19.1947 20.2241 18.3425 20.7037C17.906 20.9494 17.3465 21.0961 16.458 21.1724C15.5622 21.2494 14.411 21.25 12.8125 21.25H11.1883C9.58984 21.25 8.43868 21.2494 7.54286 21.1724C6.65442 21.0961 6.09492 20.9494 5.65833 20.7037C4.80618 20.2241 4.14548 19.4653 3.78765 18.5552C3.60432 18.089 3.53598 17.5146 3.58262 16.6241C3.62965 15.7262 3.78737 14.5859 4.00727 13.0026C4.1643 11.872 4.28128 11.0427 4.40949 10.3989C5.99834 11.9877 7.2509 13.2353 8.36198 14.0831C9.52091 14.9673 10.6136 15.4868 11.8791 15.4868C13.1446 15.4868 14.2373 14.9673 15.3962 14.0831C16.5285 13.2192 17.8076 11.94 19.4399 10.3077L19.5497 10.1979Z"
            fill="#FFFFFF"
          />
        </svg>
      )
    }
    case 'browse': {
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/c_thumb,fl_lossy,fl_progressive/v1688980256/-design-system/icon-new-order-${isSelected}.svg`}
        />
      )
    }
    case 'orders': {
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/v1691471638/-design-system/icon-orders-${isSelected}.svg`}
        />
      )
    }
    case 'matching': {
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/c_thumb,fl_lossy,fl_progressive/v1688980256/-design-system/icon-matching-${isSelected}.svg`}
        />
      )
    }
    case 'delivery': {
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/c_thumb,fl_lossy,fl_progressive/v1688980256/-design-system/icon-delivery-${isSelected}.svg`}
        />
      )
    }
    case 'team':
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/v1691471641/-design-system/icon-team-${isSelected}.svg`}
        />
      )
    case 'our-brand':
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/v1691471639/-design-system/icon-our-brand-${isSelected}.svg`}
        />
      )
    case 'creators':
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/v1691471633/-design-system/icon-creators-${isSelected}.svg`}
        />
      )
    case 'billing':
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/v1691471633/-design-system/icon-billing-${isSelected}.svg`}
        />
      )
    case 'integrations':
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/v1691471637/-design-system/icon-integrations-${isSelected}.svg`}
        />
      )
    case 'new-order':
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/v1691471637/-design-system/icon-new-order-${isSelected}.svg`}
        />
      )
    case 'support':
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/c_thumb,fl_lossy,fl_progressive/v1688980075/-design-system/icon-support-${isSelected}.svg`}
        />
      )
    case 'content':
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/c_thumb,fl_lossy,fl_progressive/v1688980075/-design-system/icon-content-${isSelected}.svg`}
        />
      )
    case 'account':
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/c_thumb,fl_lossy,fl_progressive/v1688980075/-design-system/icon-account-${isSelected}.svg`}
        />
      )
    case 'wallets':
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/c_thumb,fl_lossy,fl_progressive/v1689746783/-design-system/icon-wallets-${isSelected}.svg`}
        />
      )
    case 'settings':
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/c_thumb,fl_lossy,fl_progressive/v1689746783/-design-system/icon-settings-${isSelected}.svg`}
        />
      )
    case 'our-enterprise':
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/c_thumb,fl_lossy,fl_progressive/v1689746783/-design-system/icon-enterprise-${isSelected}.svg`}
        />
      )
    case 'our-brand-default':
      return (
        <img
          style={iconStyle}
          src={`https://res.cloudinary.com/ninety-seconds/image/upload/c_thumb,fl_lossy,fl_progressive/v1689746783/-design-system/icon-our-brand-${isSelected}.svg`}
        />
      )
    default:
      return null
  }
}

export interface Menu {
  id: string
  name: string
  subMenu?: Menu[]
  items?: Menu[]
  isSelected?: boolean
  slug?: string
  isSupportLink?: boolean
  isExternal?: boolean
  isSupport?: boolean
}

interface UserForAvatar {
  name: string
  avatar: string
  id: string
  cloudinaryId?: string
  cloudinaryType?: string
}

export interface NavigationProps {
  menuProps: Menu[]
  adminMenuProps?: Menu[]
  userForAvatar: UserForAvatar
  activeButton?: number
  brandProfileData?: BrandType
  brandId?: string
  searchToken?: string
  callbackCurrentBrandId?: (brandId: string) => void
  callbackTrigger?: (e: boolean) => void
}

const configurations = {
  production: {
    sendbirdAppId: '58CCD1E0-3275-44C1-8B52-65A34B232638',
  },
  staging: {
    sendbirdAppId: '6551A1FC-B772-4750-AB74-AB9658AF2838',
  },
}

export const getUrls = () => {
  const currentDomain = window.location.hostname.split('.').pop()
  const isProd = currentDomain === 'com'
  const config = isProd ? configurations.production : configurations.staging

  return { ...config, currentDomain: isProd ? 'com' : 'cc' }
}

const openHubSpot = () =>
  window && window.HubSpotConversations && window.HubSpotConversations.widget.open()
const closeHubSpot = () =>
  window && window.HubSpotConversations && window.HubSpotConversations.widget.close()

export default function navigation({
  userForAvatar,
  menuProps,
  adminMenuProps,
  activeButton,
  searchToken,
  callbackCurrentBrandId,
  callbackTrigger,
  ...props
}: NavigationProps) {
  const [isBrandModalOpen, setIsBrandModalOpen] = React.useState(false)
  const [isBrandModalUserOpen, setIsBrandModalUserOpen] = React.useState(false)
  const [isSearchModalOpen, setIsSearchModalOpen] = React.useState(false)
  const [searchValue, setSearchValue] = React.useState<string>('')
  const [searchResults, setSearchResults] = React.useState<TypesenseDocument[]>([])
  const [currentBrandTS, setCurrentBrandTS] = React.useState<TypesenseDocument[] | null>(null)
  const [associatedBrands, setAssociatedBrands] = React.useState<TypesenseDocument[] | null>(null)
  const [isNavCollapsed, setIsNavCollapsed] = React.useState(false)

  const [isInputTouched, setIsInputTouched] = React.useState(false)

  const user = getCurrentUser()
  const userUuid = user && user.uuid

  const modalRef = React.useRef<HTMLDivElement>(null)
  const userModalRef = React.useRef<HTMLDivElement>(null)
  const searchModalRef = React.useRef<HTMLDivElement>(null)
  const avatarWrapRef = React.useRef<HTMLDivElement>(null)
  const userWrapRef = React.useRef<HTMLDivElement>(null)

  const showSearchAndActivity = false
  const { currentDomain } = getUrls()

  const EyeIcon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="12"
        viewBox="0 0 14 12"
        fill="none"
      >
        <path
          d="M5.50016 5.99999C5.50016 5.17156 6.17174 4.49999 7.00016 4.49999C7.82859 4.49999 8.50016 5.17156 8.50016 5.99999C8.50016 6.82842 7.82859 7.49999 7.00016 7.49999C6.17174 7.49999 5.50016 6.82842 5.50016 5.99999Z"
          fill="#1E1E21"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.23465 1.73047C4.28233 0.872651 5.57286 0.166656 7.00017 0.166656C8.42747 0.166656 9.718 0.872651 10.7657 1.73047C11.8191 2.59297 12.6804 3.65242 13.2592 4.45867L13.307 4.52505C13.6554 5.00921 13.9422 5.40776 13.9422 5.99999C13.9422 6.59222 13.6554 6.99077 13.307 7.47493L13.2592 7.54131C12.6804 8.34756 11.8191 9.40701 10.7657 10.2695C9.718 11.1273 8.42747 11.8333 7.00017 11.8333C5.57286 11.8333 4.28233 11.1273 3.23465 10.2695C2.18125 9.40701 1.31991 8.34756 0.741107 7.54131L0.693372 7.47493C0.34493 6.99077 0.0581055 6.59222 0.0581055 5.99999C0.0581055 5.40776 0.344931 5.00921 0.693372 4.52505L0.741107 4.45867C1.31991 3.65242 2.18125 2.59297 3.23465 1.73047ZM7.00016 3.49999C5.61945 3.49999 4.50016 4.61928 4.50016 5.99999C4.50016 7.3807 5.61945 8.49999 7.00016 8.49999C8.38087 8.49999 9.50016 7.3807 9.50016 5.99999C9.50016 4.61928 8.38087 3.49999 7.00016 3.49999Z"
          fill="#1E1E21"
        />
      </svg>
    )
  }

  const UserIcon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 3.25C8.37665 3.25 6.25 5.37665 6.25 8C6.25 10.6234 8.37665 12.75 11 12.75C13.6234 12.75 15.75 10.6234 15.75 8C15.75 5.37665 13.6234 3.25 11 3.25ZM7.75 8C7.75 6.20507 9.20507 4.75 11 4.75C12.7949 4.75 14.25 6.20507 14.25 8C14.25 9.79493 12.7949 11.25 11 11.25C9.20507 11.25 7.75 9.79493 7.75 8Z"
          fill="#1E1E21"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 14.0485 1.51989 16.8016 3.55751 18.7571C5.48833 20.61 8.11182 21.75 11 21.75C13.8882 21.75 16.5117 20.61 18.4425 18.7571C20.4801 16.8016 21.75 14.0485 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM1.75 11C1.75 5.89137 5.89137 1.75 11 1.75C16.1086 1.75 20.25 5.89137 20.25 11C20.25 13.1948 19.4863 15.2103 18.2089 16.7966C17.4149 15.2828 15.8286 14.25 14 14.25H8C6.17143 14.25 4.58513 15.2828 3.79109 16.7966C2.51372 15.2103 1.75 13.1948 1.75 11ZM14 15.75C15.4339 15.75 16.6521 16.6792 17.0831 17.9685C15.4565 19.3898 13.3294 20.25 11 20.25C8.67062 20.25 6.54352 19.3898 4.91687 17.9685C5.34791 16.6792 6.56613 15.75 8 15.75H14Z"
          fill="#1E1E21"
        />
      </svg>
    )
  }

  const BrandModal = ({
    otherBrands,
    locationBrands,
    departmentBrands,
    onLogout,
    currentBrand,
    isUser,
  }: {
    otherBrands?: TypesenseDocument[]
    locationBrands?: TypesenseDocument[]
    departmentBrands?: TypesenseDocument[]
    onLogout: () => void
    currentBrand: TypesenseDocument
    isUser?: boolean
  }) => {
    const showLocations = locationBrands && locationBrands.length > 0
    const showDepartments = departmentBrands && departmentBrands.length > 0
    return (
      <>
        {!isUser && <DropdownSectionTitle isModal>PARENT BRAND</DropdownSectionTitle>}
        <BrandLink
          href={
            isUser
              ? `https://app.90seconds.${currentDomain}/humans/${userUuid}`
              : currentBrand &&
                `https://brand.90seconds.${currentDomain}/brand-dashboard/${currentBrand.id}`
          }
        >
          <BrandItem>
            {isUser ? (
              <>
                <UserIcon />
                <Account>Account</Account>
              </>
            ) : (
              <>
                <BrandAvatar
                  imageSrc={currentBrand && currentBrand.imageUrl}
                  alt={currentBrand && currentBrand.name}
                  displayFallback={true}
                />
                <BrandName>{currentBrand && currentBrand.name}</BrandName>
              </>
            )}
          </BrandItem>
        </BrandLink>
        <ModalSeparator />
        {locationBrands &&
          showLocations && (
            <BrandList>
              <DropdownSectionTitle isModal>LOCATIONS</DropdownSectionTitle>
              <ScrollableSection itemCount={locationBrands.length}>
                {locationBrands.map((b, index) => {
                  return (
                    <BrandLink
                      key={index}
                      href={`https://brand.90seconds.${currentDomain}/brand-dashboard/${b.id}`}
                    >
                      <BrandItem>
                        <BrandAvatar imageSrc={b.imageUrl} alt={b.name} displayFallback={true} />
                        <BrandName>{b.name}</BrandName>
                        {currentBrandTS &&
                          b.id === (currentBrandTS[0] && currentBrandTS[0].id) && <EyeIcon />}
                      </BrandItem>
                    </BrandLink>
                  )
                })}
              </ScrollableSection>
              <ModalSeparator />
            </BrandList>
          )}

        {departmentBrands &&
          showDepartments && (
            <BrandList>
              <DropdownSectionTitle isModal>DEPARTMENTS</DropdownSectionTitle>
              <ScrollableSection itemCount={departmentBrands.length}>
                {departmentBrands.map((b, index) => {
                  return (
                    <BrandLink
                      key={index}
                      href={`https://brand.90seconds.${currentDomain}/brand-dashboard/${b.id}`}
                    >
                      <BrandItem>
                        <BrandAvatar imageSrc={b.imageUrl} alt={b.name} displayFallback={true} />
                        <BrandName>{b.name}</BrandName>
                        {currentBrandTS &&
                          b.id === (currentBrandTS[0] && currentBrandTS[0].id) && <EyeIcon />}
                      </BrandItem>
                    </BrandLink>
                  )
                })}
              </ScrollableSection>
              <ModalSeparator />
            </BrandList>
          )}

        {otherBrands &&
          otherBrands.length > 0 && (
            <BrandList>
              <DropdownSectionTitle isModal>MY OTHER BRANDS</DropdownSectionTitle>
              <ScrollableSection itemCount={otherBrands.length}>
                {otherBrands.map((b, index) => {
                  return (
                    <BrandLink
                      key={index}
                      href={`https://brand.90seconds.${currentDomain}/brand-dashboard/${b.id}`}
                    >
                      <BrandItem>
                        <BrandAvatar imageSrc={b.imageUrl} alt={b.name} displayFallback={true} />
                        <BrandName>{b.name}</BrandName>
                        {currentBrandTS &&
                          b.id === (currentBrandTS[0] && currentBrandTS[0].id) && <EyeIcon />}
                      </BrandItem>
                    </BrandLink>
                  )
                })}
              </ScrollableSection>
              <ModalSeparator />
            </BrandList>
          )}
        {!isUser && (
          <>
            <AddSubBrand
              href={`https://brand.90seconds.${currentDomain}/brand-dashboard/sub-brands/${getDashboardId()}`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM1.30612 8C1.30612 4.30307 4.30307 1.30612 8 1.30612C11.6969 1.30612 14.6939 4.30307 14.6939 8C14.6939 11.6969 11.6969 14.6939 8 14.6939C4.30307 14.6939 1.30612 11.6969 1.30612 8ZM8.81521 5.06122C8.81521 4.70055 8.52282 4.40816 8.16215 4.40816C7.80147 4.40816 7.50909 4.70055 7.50909 5.06122V7.34694H5.22337C4.8627 7.34694 4.57031 7.63932 4.57031 8C4.57031 8.36068 4.8627 8.65306 5.22337 8.65306H7.50909V10.9388C7.50909 11.2995 7.80147 11.5918 8.16215 11.5918C8.52282 11.5918 8.81521 11.2995 8.81521 10.9388V8.65306H11.1009C11.4616 8.65306 11.754 8.36068 11.754 8C11.754 7.63932 11.4616 7.34694 11.1009 7.34694H8.81521V5.06122Z"
                  fill="#1E1E21"
                />
              </svg>{' '}
              Add sub-brand
            </AddSubBrand>
          </>
        )}
        {isUser && (
          <>
            <LogoutButton onClick={onLogout}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M4.94614 0.400003H4.94613L4.93625 0.400002C4.37716 0.399956 4.02428 0.399927 3.71803 0.448431C2.03499 0.714999 0.714999 2.03499 0.448431 3.71803C0.399927 4.02428 0.399956 4.37716 0.400002 4.93626L0.400003 4.94613V4.94613L0.400003 9.05388L0.400002 9.06376C0.399956 9.62285 0.399927 9.97573 0.448431 10.282C0.714999 11.965 2.03499 13.285 3.71803 13.5516C4.02428 13.6001 4.37717 13.6001 4.93628 13.6H4.94615L5.66667 13.6C6.55146 13.6 7.36958 13.3071 8.02702 12.8133C8.29197 12.6143 8.34543 12.2382 8.14641 11.9732C7.9474 11.7083 7.57128 11.6548 7.30633 11.8538C6.84956 12.1969 6.2827 12.4 5.66667 12.4H5.00001C4.35756 12.4 4.10643 12.3981 3.90575 12.3664C2.73618 12.1811 1.8189 11.2638 1.63366 10.0943C1.60187 9.89358 1.60001 9.64245 1.60001 9L1.60001 5C1.60001 4.35756 1.60187 4.10643 1.63366 3.90575C1.8189 2.73618 2.73618 1.8189 3.90575 1.63366C4.10643 1.60187 4.35756 1.60001 5.00001 1.60001H5.66667C6.2827 1.60001 6.84956 1.80308 7.30633 2.14617C7.57128 2.34518 7.9474 2.29173 8.14641 2.02678C8.34543 1.76182 8.29197 1.3857 8.02702 1.18669C7.36958 0.692866 6.55146 0.400006 5.66667 0.400006L4.94614 0.400003ZM10.7061 3.86319C10.4465 3.65731 10.0691 3.70091 9.86319 3.96056C9.65731 4.22022 9.70091 4.59761 9.96056 4.80348L11.1359 5.73538C11.4864 6.01327 11.7511 6.22379 11.9516 6.40001L3.66667 6.4C3.3353 6.4 3.06667 6.66863 3.06667 7C3.06667 7.33138 3.3353 7.6 3.66667 7.6L11.9516 7.60001C11.7511 7.77622 11.4864 7.98674 11.1359 8.26463L9.96056 9.19652C9.70091 9.4024 9.65731 9.77979 9.86319 10.0394C10.0691 10.2991 10.4465 10.3427 10.7061 10.1368L11.9053 9.18599L11.9099 9.18235C12.3545 8.82986 12.728 8.5337 12.9956 8.26718C13.2714 7.99237 13.5134 7.67477 13.5793 7.26152C13.5931 7.17493 13.6 7.08755 13.6 7.00001C13.6 6.91246 13.5931 6.82508 13.5793 6.73849C13.5134 6.32525 13.2714 6.00764 12.9956 5.73283C12.728 5.4663 12.3545 5.17015 11.9099 4.81765L11.9053 4.81402L10.7061 3.86319Z"
                  fill="#1E1E21"
                  stroke="#1E1E21"
                  strokeWidth="0.2"
                  strokeLinecap="round"
                />
              </svg>{' '}
              Log out
            </LogoutButton>
          </>
        )}
      </>
    )
  }

  const useOutsideClickListener = (ref, triggerRef, callback) => {
    React.useEffect(
      () => {
        function handleClickOutside(event) {
          if (
            ref.current &&
            !ref.current.contains(event.target) &&
            triggerRef.current &&
            !triggerRef.current.contains(event.target)
          ) {
            callback()
          }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
          document.removeEventListener('mousedown', handleClickOutside)
        }
      },
      [ref]
    )
  }
  useOutsideClickListener(modalRef, avatarWrapRef, () => setIsBrandModalOpen(false))
  useOutsideClickListener(userModalRef, userWrapRef, () => setIsBrandModalUserOpen(false))
  useOutsideClickListener(searchModalRef, avatarWrapRef, () => setIsSearchModalOpen(false))

  const userBrands: SearchParameters = {
    page: '1',
    per_page: '100',
    query_by: 'name',
    q: searchValue,
  }

  const organisationFilter = (): string => {
    if (getDashboardId().includes('-')) {
      return `id:=${getDashboardId()}`
    }
    return `vaasId:=${getDashboardId()}`
  }

  const currentBrandParams: SearchParameters = {
    filter_by: organisationFilter(),
    page: '1',
    per_page: '100',
    query_by: 'name',
    q: '*',
  }

  const associatedBrandsParams: SearchParameters = {
    page: '1',
    per_page: '100',
    query_by: 'name',
    q: '*',
  }

  const TSCollection =
    window.env && window.env.ENVIRONMENT === 'production'
      ? 'organisations'
      : 'organisations_staging'

  React.useEffect(
    () => {
      searchToken !== '' &&
        searchValue !== '' &&
        typesenseQuery(searchToken || '', typesenseConfig, TSCollection, userBrands)
          .then(result => {
            setSearchResults(result.hits.map(hit => hit.document))
          })
          .catch(error => console.error('Failed to query Typesense:', error))
    },
    [searchValue, searchToken]
  )

  React.useEffect(
    () => {
      searchToken !== '' &&
        getDashboardId() !== '' &&
        typesenseQuery(searchToken || '', typesenseConfig, TSCollection, currentBrandParams)
          .then(result => {
            setCurrentBrandTS(result.hits.map(hit => hit.document))
          })
          .catch(error => console.error('Failed to query Typesense:', error))
    },
    [searchToken, getDashboardId]
  )

  React.useEffect(
    () => {
      searchToken !== '' &&
        getDashboardId() !== '' &&
        typesenseQuery(searchToken || '', typesenseConfig, TSCollection, associatedBrandsParams)
          .then(result => {
            setAssociatedBrands(result.hits.map(hit => hit.document))
          })
          .catch(error => console.error('Failed to query Typesense:', error))
    },
    [searchToken, getDashboardId]
  )

  const brandsArray = Array.isArray(searchResults) ? searchResults : []

  React.useEffect(
    () => {
      const timeoutId = setTimeout(() => {
        if (currentBrandTS && currentBrandTS.length === 0) {
          window.location.href = `${window.env.BRAND_BASE_URL}/brand-dashboard/`
        }
      }, 3000)
      return () => clearTimeout(timeoutId)
    },
    [currentBrandTS]
  )

  const parentBrand = React.useMemo(
    () => {
      if (currentBrandTS && currentBrandTS[0] && currentBrandTS[0].parent) {
        return (
          brandsArray.find(
            b => b.id === (currentBrandTS[0].parent && currentBrandTS[0].parent.id)
          ) || ((currentBrandTS[0].parent as unknown) as TypesenseDocument)
        )
      }
      return currentBrandTS && currentBrandTS[0]
    },
    [brandsArray, currentBrandTS]
  )

  const TSlocations = associatedBrands
    ? associatedBrands
        .filter(
          b =>
            b.parent &&
            b.parent.relationship === BrandRelationship.Location &&
            b.parent &&
            b.parent.id === (parentBrand && parentBrand.id)
        )
        .sort((a, b) => a.name.localeCompare(b.name))
    : []

  const TSdepartments = associatedBrands
    ? associatedBrands
        .filter(
          b =>
            b.parent &&
            b.parent.relationship === BrandRelationship.Department &&
            b.parent &&
            b.parent.id === (parentBrand && parentBrand.id)
        )
        .sort((a, b) => a.name.localeCompare(b.name))
    : []

  const otherBrandsTS = associatedBrands
    ? associatedBrands
        .filter(
          br =>
            ![
              parentBrand && parentBrand.id,
              ...TSlocations.map(b => b.id),
              ...TSdepartments.map(b => b.id),
            ].includes(br.id)
        )
        .sort((a, b) => a.name.localeCompare(b.name))
    : []

  const currentBrandId = currentBrandTS && currentBrandTS[0] && currentBrandTS[0].id
  const currentBrandImage = currentBrandTS && currentBrandTS[0] && currentBrandTS[0].imageUrl
  const currentBrandName = currentBrandTS && currentBrandTS[0] && currentBrandTS[0].name
  const filteredSearchResults = searchResults.filter(result =>
    result.name.toLowerCase().includes(searchValue.toLowerCase())
  )
  callbackCurrentBrandId && currentBrandId && callbackCurrentBrandId(currentBrandId)

  const searchInputRef = React.useRef<HTMLInputElement>(null)
  const handleSearchInputFocus = () => {
    searchInputRef && searchInputRef.current && searchInputRef.current.focus()
  }

  const logoutAndRedirect = async () => {
    try {
      const response = await fetch(
        `${window.env.GEN1_BASE_URL}/sign_out?return_to=${window.env.GEN1_BASE_URL}`,
        {
          credentials: 'include',
          method: 'DELETE',
        }
      )
      const data = await response.json()

      logout()
      window.location.assign(data.redirect_to || window.env.GEN1_BASE_URL)
    } catch {
      notification.error({
        message: 'There was an error logging you out. Please try again.',
        description: null,
      })
    }
  }
  const recentBrands = JSON.parse(
    localStorage.getItem('ninety-navigation-recent-brands') || '[]'
  ) as TypesenseDocument[]
  const uniqueRecentBrands = uniqBy(recentBrands, a => a.id)

  React.useEffect(
    () => {
      callbackTrigger && callbackTrigger(isNavCollapsed)
    },
    [isNavCollapsed]
  )
  return (
    <>
      <TooltipContent />
      {isBrandModalOpen && (
        <ModalContent ref={modalRef}>
          <BrandModal
            locationBrands={TSlocations}
            departmentBrands={TSdepartments}
            otherBrands={otherBrandsTS}
            onLogout={() => logoutAndRedirect()}
            currentBrand={parentBrand as TypesenseDocument}
          />
        </ModalContent>
      )}
      {isBrandModalUserOpen && (
        <ModalContent ref={userModalRef} style={{ width: '179px' }}>
          <BrandModal
            onLogout={() => logoutAndRedirect()}
            currentBrand={(currentBrandTS && (currentBrandTS[0] as unknown)) as TypesenseDocument}
            isUser={true}
          />
        </ModalContent>
      )}
      {isSearchModalOpen && (
        <ModalContent ref={searchModalRef} style={{ top: '210px' }}>
          <SearchWrapper>
            <img
              src="https://res.cloudinary.com/ninety-seconds/image/upload/v1647311573/Content%20Inspiration/icon-search-white.svg"
              alt="search"
            />
            <SearchInput
              placeholder="Find a brand"
              value={searchValue}
              onChange={e => {
                setSearchValue(e.target.value)
                setIsInputTouched(true)
              }}
              ref={searchInputRef}
            />
          </SearchWrapper>
          {uniqueRecentBrands.length > 0 &&
            searchValue === '' && (
              <>
                <SearchSeparator />
                <DropdownSectionTitle isModal={true}>
                  RECENT BRANDS ({uniqueRecentBrands.length})
                </DropdownSectionTitle>
                <ResultsWrapper count={uniqueRecentBrands.length} recentBrands={true}>
                  {uniqueRecentBrands.map(br => (
                    <ResultLink
                      key={br.id}
                      href={`https://brand.90seconds.${currentDomain}/brand-dashboard/${br.id}`}
                    >
                      <Avatar
                        alt={br.name}
                        imageSrc={`https://res.cloudinary.com/ninety-seconds/image/upload/v1647311573/Content%20Inspiration/icon-search-white.svg`}
                        displayFallback={true}
                      />
                      <ResultName>{br.name}</ResultName>
                      {currentBrandTS &&
                        br.id === (currentBrandTS[0] && currentBrandTS[0].id) && <EyeIcon />}
                    </ResultLink>
                  ))}
                </ResultsWrapper>
              </>
            )}
          {searchValue === '' && isInputTouched && <SearchSeparator />}
          {isInputTouched && (
            <ResultsWrapper count={filteredSearchResults.length}>
              {filteredSearchResults.map(result => (
                <Tippy
                  content={<TooltipWrapper>{result.name}</TooltipWrapper>}
                  placement="top"
                  arrow={true}
                  appendTo={document.body}
                  boundary="viewport"
                  duration={0}
                >
                  <ResultLink
                    key={result.id}
                    onClick={e => {
                      e.preventDefault()
                      const updatedSearchResults = [result, ...searchResults.slice(0, 4)]
                      localStorage.setItem(
                        'ninety-navigation-recent-brands',
                        JSON.stringify(updatedSearchResults)
                      )
                      window.location.href = `https://brand.90seconds.${currentDomain}/brand-dashboard/${
                        result.id
                      }`
                    }}
                  >
                    <Avatar
                      alt={result.name}
                      imageSrc={`https://res.cloudinary.com/ninety-seconds/image/upload/v1647311573/Content%20Inspiration/icon-search-white.svg`}
                      displayFallback={true}
                    />
                    <ResultName>{result.name}</ResultName>
                    {currentBrandTS &&
                      result.id === (currentBrandTS[0] && currentBrandTS[0].id) && <EyeIcon />}
                  </ResultLink>
                </Tippy>
              ))}
            </ResultsWrapper>
          )}
        </ModalContent>
      )}

      <NavTrigger
        isNavCollapsed={isNavCollapsed}
        onClick={() => setIsNavCollapsed(prev => !prev)}
      />
      <Wrap {...props} isManager={isAdmin()} isNavCollapsed={isNavCollapsed}>
        <TopWrapp>
          <LogoWrap href="/">
            <Logo src="https://res.cloudinary.com/ninety-seconds/image/upload/f_auto,q_auto,c_thumb,fl_lossy,fl_progressive/-design-system/-logo-2023/iconmark/white.svg" />
          </LogoWrap>
          {!isNavCollapsed && (
            <LogoWrap href={`https://app.90seconds.${domainHelper()}/search`}>
              <SearchIcon
                src="https://res.cloudinary.com/ninety-seconds/image/upload/v1647311573/Content%20Inspiration/icon-search-white.svg"
                alt="search"
              />
            </LogoWrap>
          )}
        </TopWrapp>
        {isBrand() &&
          !isAdmin() && (
            <UserAvatarWrap
              isOpen={isBrandModalOpen}
              onClick={() => setIsBrandModalOpen(prev => !prev)}
              ref={avatarWrapRef}
              isNavCollapsed={isNavCollapsed}
            >
              <BrandNameWrapper onClick={e => e.preventDefault()}>
                {currentBrandImage === 'placeholders/icon-brand' ||
                currentBrandImage === undefined ? (
                  <AvatarMissing isNavCollapsed={isNavCollapsed}>
                    <span>
                      {currentBrandTS && currentBrandTS.length === 0
                        ? null
                        : getTwoLetter(currentBrandName || '')}
                    </span>
                  </AvatarMissing>
                ) : (
                  <AvatarStyled
                    alt={currentBrandName || ''}
                    displayFallback={false}
                    src={currentBrandImage || ''}
                    isNavCollapsed={isNavCollapsed}
                  />
                )}
                {!isNavCollapsed && (
                  <span className="userName" title={currentBrandName || ''}>
                    {currentBrandTS && currentBrandTS.length === 0
                      ? 'Select Brand'
                      : currentBrandName}
                  </span>
                )}
              </BrandNameWrapper>
              {!isNavCollapsed && ArrowIconWhite}
            </UserAvatarWrap>
          )}
        <UserAvatarWrap
          isOpen={isBrandModalUserOpen}
          onClick={() => setIsBrandModalUserOpen(prev => !prev)}
          ref={userWrapRef}
          isNavCollapsed={isNavCollapsed}
        >
          <BrandNameWrapper>
            <AvatarStyled
              alt={userForAvatar.name}
              displayFallback={true}
              src={`https://res.cloudinary.com/ninety-seconds/image/fetch/https://storage.googleapis.com/90seconds-${
                domainHelper() === 'cc' ? 'staging' : 'production'
              }-attachments/human/avatar/${userForAvatar.id}/thumbnail_${userForAvatar.avatar}`}
              isNavCollapsed={isNavCollapsed}
            />
            {!isNavCollapsed && (
              <span className="userName" title={userForAvatar.name}>
                {userForAvatar.name}
              </span>
            )}
          </BrandNameWrapper>
          {!isNavCollapsed && ArrowIconWhite}
        </UserAvatarWrap>
        <MenuContainer isAdmin={isAdmin()}>
          <ChatAndActivityMenuItem
            isLast={false}
            href={`https://chat.90seconds.${domainHelper()}${
              currentBrandId ? `/brands/${currentBrandId}` : ''
            }`}
            rel="noopener noreferrer"
          >
            <Icon src="https://res.cloudinary.com/ninety-seconds/image/upload/v1721650461/button-chat-dark.svg" />
            {!isNavCollapsed && <Label>Chat</Label>}
            {/* <Badge>1</Badge> */}
          </ChatAndActivityMenuItem>
          <ChatAndActivityMenuItem
            href={`https://chat.90seconds.${domainHelper()}/activity${
              currentBrandId ? `/brands/${currentBrandId}` : ''
            }`}
            rel="noopener noreferrer"
            isLast={true}
          >
            <Icon src="https://res.cloudinary.com/ninety-seconds/image/upload/v1721650337/button-activity-dark.svg" />
            {!isNavCollapsed && <Label>Activity</Label>}
            {/* <Badge>7</Badge> */}
          </ChatAndActivityMenuItem>
        </MenuContainer>
        {isAdmin() && (
          <>
            {!isNavCollapsed && <SectionTitle>OPERATE ON BEHALF</SectionTitle>}
            <UserAvatarWrap
              onClick={async () => {
                await setIsSearchModalOpen(prev => !prev)
                handleSearchInputFocus()
              }}
              isOpen={isSearchModalOpen}
              ref={avatarWrapRef}
              isNavCollapsed={isNavCollapsed}
            >
              <BrandNameWrapper onClick={e => e.preventDefault()}>
                {currentBrandImage === 'placeholders/icon-brand' ||
                currentBrandImage === undefined ? (
                  <AvatarMissing isNavCollapsed={isNavCollapsed}>
                    <span>{getTwoLetter(currentBrandName || '')}</span>
                  </AvatarMissing>
                ) : currentBrandTS && currentBrandTS.length === 0 ? (
                  <AvatarMissing isNavCollapsed={isNavCollapsed}>
                    <span />
                  </AvatarMissing>
                ) : (
                  <AvatarStyled
                    alt={currentBrandName || ''}
                    displayFallback={false}
                    src={currentBrandImage || ''}
                    isNavCollapsed={isNavCollapsed}
                  />
                )}
                {!isNavCollapsed && (
                  <span className="userName" title={currentBrandName || ''}>
                    {currentBrandTS && currentBrandTS.length === 0
                      ? 'Select Brand'
                      : currentBrandName}
                  </span>
                )}
              </BrandNameWrapper>
              {!isNavCollapsed && ArrowIconWhite}
            </UserAvatarWrap>
          </>
        )}
        {menuProps.map(menu => {
          return (
            <MenuItem
              hasSubMenu={!!(menu.subMenu && menu.subMenu.length)}
              isSelected={!!menu.isSelected}
              data-sidebar-id={menu.id}
              key={menu.id}
            >
              {menu.isExternal ? (
                <a href={menu.slug}>
                  <IconMap id={menu.id} isSelected={menu.isSelected ? 'active' : 'default'} />
                  {!isNavCollapsed && menu.name}
                </a>
              ) : (
                <Route
                  render={({ history }) => (
                    <a
                      href={menu.slug}
                      onClick={e => {
                        e.preventDefault()
                        if (menu.isSupport) {
                          openHubSpot()
                        }
                        if (menu.slug) {
                          history.push(menu.slug)
                          closeHubSpot()
                        }
                      }}
                    >
                      <IconMap id={menu.id} isSelected={menu.isSelected ? 'active' : 'default'} />
                      {!isNavCollapsed && menu.name}
                    </a>
                  )}
                />
              )}
            </MenuItem>
          )
        })}
        {isAdmin() && (
          <>
            {isNavCollapsed && <Hr />}
            {!isNavCollapsed && <SectionTitle>CONCIERGE NAVIGATION</SectionTitle>}
            {adminMenuProps &&
              adminMenuProps.map(menu => {
                return (
                  <MenuItem
                    hasSubMenu={!!(menu.subMenu && menu.subMenu.length)}
                    isSelected={!!menu.isSelected}
                    data-sidebar-id={menu.id}
                    key={menu.id}
                  >
                    {menu.isExternal ? (
                      <a href={menu.slug}>
                        <IconMap id={menu.id} isSelected={menu.isSelected ? 'active' : 'default'} />
                        {!isNavCollapsed && menu.name}
                      </a>
                    ) : (
                      <Route
                        render={({ history }) => (
                          <a
                            href={menu.slug}
                            onClick={e => {
                              e.preventDefault()
                              if (menu.isSupport) {
                                openHubSpot()
                              }
                              if (menu.slug) {
                                history.push(menu.slug)
                                closeHubSpot()
                              }
                            }}
                          >
                            <IconMap
                              id={menu.id}
                              isSelected={menu.isSelected ? 'active' : 'default'}
                            />
                            {!isNavCollapsed && menu.name}
                          </a>
                        )}
                      />
                    )}
                  </MenuItem>
                )
              })}
            <ConciergeReports isNavCollapsed={isNavCollapsed} />
          </>
        )}
        {showSearchAndActivity && <ActiveItems />}
      </Wrap>
    </>
  )
}

const ActiveItems = () => {
  const [activeOrdersOpen, setActiveOrdersOpen] = React.useState(false)
  const [activeMatchesOpen, setActiveMatchesOpen] = React.useState(false)
  const [activeDeliveriesOpen, setActiveDeliveriesOpen] = React.useState(false)

  return (
    <Container>
      <Section>
        <SectionHeader onClick={() => setActiveOrdersOpen(!activeOrdersOpen)}>
          <SectionTitle>ACTIVE ORDERS</SectionTitle>
          <Arrow isOpen={activeOrdersOpen}>{ArrowIcon}</Arrow>
        </SectionHeader>
        {activeOrdersOpen && (
          <ItemList>
            <Item>{BulletIcon} 06 Customer Story...</Item>
            <Item>{BulletIcon} Launch Event</Item>
            <SubItem>Product Demo 12 J..</SubItem>
            <SubItem>07 Customer Story</SubItem>
            <SubItem>08 Customer Story</SubItem>
          </ItemList>
        )}
      </Section>

      <Section>
        <SectionHeader onClick={() => setActiveMatchesOpen(!activeMatchesOpen)}>
          <SectionTitle>ACTIVE MATCHES</SectionTitle>
          <Arrow isOpen={activeMatchesOpen}>{ArrowIcon}</Arrow>
        </SectionHeader>
        {activeMatchesOpen && (
          <ItemList>
            <Item>{BulletIcon} Singapore Shoot</Item>
            <Item>{BulletIcon} London Shoot</Item>
          </ItemList>
        )}
      </Section>

      <Section>
        <SectionHeader onClick={() => setActiveDeliveriesOpen(!activeDeliveriesOpen)}>
          <SectionTitle>ACTIVE DELIVERIES</SectionTitle>
          <Arrow isOpen={activeDeliveriesOpen}>{ArrowIcon}</Arrow>
        </SectionHeader>
        {activeDeliveriesOpen && (
          <ItemList>
            <SubItem>Standard Edit</SubItem>
            <SubItem>Standard Edit</SubItem>
            <SubItem>08 Customer Story</SubItem>
          </ItemList>
        )}
      </Section>
    </Container>
  )
}



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/Navigation/Navigation.tsx